import { FundingTrigger, UpdatePreFundingSettingsRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function usePreFundingSettings() {
  const [fetching, setFetching] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [fundingTrigger, setFundingTrigger] = useState<FundingTrigger>('never');
  const [lastSavedTrigger, setLastSavedTrigger] = useState<FundingTrigger>('never');

  async function fetchPreFundingSettings() {
    try {
      setFetching(true);
      const res = await api.fetchPreFundingSettings();

      if (!res.Success) throw new Error(res.ErrorMessage);

      setFundingTrigger(res.PreFundingSettings.FundingTrigger);
      setLastSavedTrigger(res.PreFundingSettings.FundingTrigger);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  async function updatePreFundingSettings(params: UpdatePreFundingSettingsRequest) {
    try {
      setUpdating(true);
      const res = await api.updatePreFundingSettings(params);

      if (!res.Success) throw new Error(res.ErrorMessage);

      setFundingTrigger(res.PreFundingSettings.FundingTrigger);
      setLastSavedTrigger(res.PreFundingSettings.FundingTrigger);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setUpdating(false);
    }
  }

  return {
    fetching,
    updating,
    fundingTrigger,
    handleSelectTrigger: setFundingTrigger,
    lastSavedTrigger,
    fetchPreFundingSettings,
    updatePreFundingSettings,
  };
}
